import getAngularService from './get_angular_service';
import qs from 'qs';
import _ from 'underscore';

const api = {
  get: (url: string, params: any = {}) => {
    const $q = getAngularService('$q');
    const http = getAngularService('$http');
    const deferred = $q.defer();

    const query = _.isEmpty(params) ? '' : `?${qs.stringify(params, { arrayFormat: 'brackets' })}`;

    http.get(`${url}${query}`).then(
      (response) => {
        let data;
        if (response.data.collection && response.data.page) {
          const { collection, ...meta } = response.data;
          data = collection;
          data.meta = meta;
        } else {
          data = response.data;
        }

        deferred.resolve(data);
      },
      (response) => {
        deferred.reject(response);
      },
    );

    return deferred.promise;
  },
  patch: (url: string, params = {}, config?: any) => {
    const $q = getAngularService('$q');
    const http = getAngularService('$http');
    const deferred = $q.defer();

    http.patch(url, params, config).then(
      (response) => {
        deferred.resolve(response.data);
      },
      (response) => {
        deferred.reject(response);
      },
    );

    return deferred.promise;
  },
  put: (url: string, params = {}, config?: any) => {
    const $q = getAngularService('$q');
    const http = getAngularService('$http');
    const deferred = $q.defer();

    http.put(url, params, config).then(
      (response) => {
        deferred.resolve(response.data);
      },
      (response) => {
        deferred.reject(response);
      },
    );

    return deferred.promise;
  },
  post: (url: string, params = {}) => {
    const $q = getAngularService('$q');
    const http = getAngularService('$http');
    const deferred = $q.defer();

    http.post(url, params).then(
      (response) => {
        deferred.resolve(response.data);
      },
      (response) => {
        deferred.reject(response);
      },
    );

    return deferred.promise;
  },
  delete: (url: string, params = {}) => {
    const $q = getAngularService('$q');
    const http = getAngularService('$http');
    const deferred = $q.defer();

    http.delete(url, { params: params }).then(
      (response) => {
        deferred.resolve(response.data);
      },
      (response) => {
        deferred.reject(response);
      },
    );

    return deferred.promise;
  },
};

export default api;
